import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'sampleTestingSchedule',
  components: {
  },
  props: {
    dataObj: {
      type: Object,
      default: []
    },
  },
  data: function () {
    return {

    }
  },
  created() {
    if (this.dataObj.appData.testingParameters.length <= 0)
      this.$alertMsg(this.$t('lims.noSamplesTestingSchedule'), 1);
  },
  watch: {

  },
  methods: {
    toBeTestedFunc(elem) {
      if (elem.isLabTest == false) {
        //reset method if tobetested is false
        elem.method = '';
        elem.methodId = 0;
      }
      else {
        //fill method dropdown
        if (this.dataObj.appData.testingMethods.length > 0) {
          elem.method = this.dataObj.appData.testingMethods[0].text;
          elem.methodId = this.dataObj.appData.testingMethods[0].value;
        }
      }
    },
    validateAppData() {
      return true;
    },
  }
}



